var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3615 14.2745C21.57 14.2745 23.47 12.3025 23.47 9.73449C23.47 7.19749 21.56 5.31799 19.3615 5.31799C17.1635 5.31799 15.253 7.23849 15.253 9.75499C15.253 12.3025 17.153 14.2745 19.3615 14.2745ZM7.539 14.511C9.4495 14.511 11.114 12.785 11.114 10.556C11.114 8.34799 9.439 6.71449 7.539 6.71449C5.629 6.71449 3.944 8.38899 3.9545 10.577C3.9545 12.785 5.6185 14.511 7.5395 14.511M1.808 23.786H9.614C8.546 22.235 9.8505 19.1125 12.059 17.4075C10.919 16.6475 9.4495 16.0825 7.529 16.0825C2.8965 16.082 0 19.502 0 22.3475C0 23.2725 0.5135 23.786 1.808 23.786ZM12.901 23.786H25.812C27.4245 23.786 28 23.3235 28 22.4195C28 19.7695 24.682 16.113 19.3515 16.113C14.031 16.113 10.713 19.7695 10.713 22.42C10.713 23.3235 11.288 23.786 12.901 23.786Z",
    fill: "#9BA4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatients);
export default __webpack_public_path__ + "static/media/patients.d8e927bfec4ff0ff84730f087a635e72.svg";
export { ForwardRef as ReactComponent };